/**
 * Búsqueda por palabras (Rodrigo, 2026-10-25): «coca 2 ret» encuentra «COCA COLA 2 LTS RET». Cada
 * palabra debe estar en alguno de los campos, en cualquier orden, sin distinguir mayúsculas ni
 * tildes. Es el mismo criterio que la búsqueda del servidor (clientes y productos).
 */
const normal = (t: string) =>
  t
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

export function coincide(texto: string, ...campos: (string | null | undefined)[]): boolean {
  const palabras = normal(texto).split(/\s+/).filter(Boolean);
  if (!palabras.length) return true;
  const donde = normal(campos.filter(Boolean).join(' '));
  return palabras.every((w) => donde.includes(w));
}
